module.exports = __webpack_public_path__ + "static/media/45.c55cc4f2.jpg";